import axios from "axios";

const search = axios.create({
    baseURL:'https://api.bbf-bike.de/api/bbf/articles/',
    timeout:5000,
    headers:{
        'Content-Type':'application/json'
    }
});

export default search;